import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { ViewElsewhereIcon } from "@hl/shared-features/lib/assets/icons.generated";
import { Modal, Text, List, Anchor, Group } from "@mantine/core";

import { EXTERNAL_URL } from "../../config";

export const RequestVerificationModal = ({
  isOpened,
  onClose,
}: {
  isOpened: boolean;
  onClose: () => void;
}) => (
  <Modal opened={isOpened} onClose={onClose} size="lg" title="Verification">
    <Text size="sm" fw={WEIGHT_BOLD}>
      Benefits of verification:
    </Text>
    <List pl="xs" size="sm">
      <List.Item>A badge next to your name</List.Item>
    </List>
    <Text size="sm" fw={WEIGHT_BOLD}>
      Getting Verified:
    </Text>
    <List pl="xs" size="sm">
      <List.Item>Connect your Twitter account to your profile</List.Item>
      <List.Item>
        <Group spacing={6}>
          <Text size="sm">Fill out the</Text>
          <Anchor
            size="sm"
            href={EXTERNAL_URL.VERIFICATION_REQUEST_FORM}
            target="_blank"
          >
            <Text underline size="sm" span>
              verification request form
            </Text>
          </Anchor>
          <ViewElsewhereIcon />
        </Group>
      </List.Item>
    </List>
    <Text mt="sm" size="sm" fw={WEIGHT_BOLD}>
      Verification Criteria:
    </Text>
    <List pl="xs" type="ordered" size="sm">
      <List.Item>
        Relevant work history on Highlight or other platforms
      </List.Item>
      <List.Item>No history of unusual or fraudulent activity</List.Item>
      <List.Item>Verifiable identity</List.Item>
    </List>
    <Text mt="sm" size="sm" fw={WEIGHT_BOLD}>
      Tips for Successful Verification:
    </Text>
    <List pl="xs" size="sm">
      <List.Item>Link your Twitter account to your profile</List.Item>
      <List.Item>
        Publish work on Highlight to establish artistic identity
      </List.Item>
      <List.Item>
        Have multiple minted works and/or a substantial external body of work
      </List.Item>
    </List>
    <Text mt="xs" size="sm">
      Note: Verification is not mandatory for minting, but adds trust and
      authenticity. Lack of verification does not restrict minting.
    </Text>
    <Group spacing={5} mt={20}>
      <Anchor
        href={EXTERNAL_URL.VERIFICATION_SUPPORT}
        target="_blank"
        size="sm"
      >
        <Text underline size="sm" span>
          Learn more about verification
        </Text>
      </Anchor>
      <ViewElsewhereIcon />
    </Group>
  </Modal>
);
